import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/qms-psmf-services")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/qms-psmf-services"),
  component: PVOffering,
});

